import { useEffect, useState } from "react";
import { BrainCircuit, Zap, Moon } from "lucide-react";
import api from "../api";
import { useUnit } from "../context/UnitContext";

const Insight = ({ Icon, label, haut, bas, unit }) => {
  if (haut == null || bas == null) {
    return (
      <div className="bg-[#14141A] border border-[#2E2E3A] p-3 flex-1">
        <p className="text-[10px] uppercase tracking-widest text-[#B0B0B4] flex items-center gap-1"><Icon size={12} /> {label}</p>
        <p className="text-[#666] text-xs mt-1">Pas encore assez de séances hautes et basses pour comparer.</p>
      </div>
    );
  }
  const pct = bas > 0 ? Math.round(((haut - bas) / bas) * 100) : 0;
  const better = pct >= 0;
  return (
    <div className="bg-[#14141A] border border-[#2E2E3A] p-3 flex-1">
      <p className="text-[10px] uppercase tracking-widest text-[#B0B0B4] flex items-center gap-1"><Icon size={12} /> {label}</p>
      <p className={`font-display text-3xl mt-1 ${better ? "text-[#32D74B]" : "text-[#FF3B30]"}`}>{better ? "+" : ""}{pct}%</p>
      <p className="text-[#B0B0B4] text-[10px] mt-0.5">de volume quand {label.toLowerCase()} ≥ 4/5 ({haut} vs {bas} {unit})</p>
    </div>
  );
};

export const InsightsSection = () => {
  const { unit, dw } = useUnit();
  const [ins, setIns] = useState(null);

  useEffect(() => {
    api.get("/journal/insights").then(({ data }) => setIns(data)).catch(() => {});
  }, []);

  if (!ins) return null;
  return (
    <section data-testid="insights-section">
      <h2 className="font-display text-2xl text-white mb-2 flex items-center gap-2">
        CORRÉLATIONS JOURNAL <BrainCircuit size={18} className="text-[#FF3B30]" />
      </h2>
      {ins.n < 3 ? (
        <p className="text-[#B0B0B4] text-xs bg-[#14141A] border border-[#2E2E3A] px-3 py-2.5" data-testid="insights-empty">
          Remplis ton journal de séance (énergie, sommeil) après au moins 3 séances pour découvrir ce qui booste tes performances.
          {ins.n > 0 && ` (${ins.n}/3)`}
        </p>
      ) : (
        <div className="flex gap-2">
          <Insight Icon={Zap} label="Énergie" unit={unit}
            haut={ins.energie_haut != null ? Math.round(dw(ins.energie_haut)) : null}
            bas={ins.energie_bas != null ? Math.round(dw(ins.energie_bas)) : null} />
          <Insight Icon={Moon} label="Sommeil" unit={unit}
            haut={ins.sommeil_haut != null ? Math.round(dw(ins.sommeil_haut)) : null}
            bas={ins.sommeil_bas != null ? Math.round(dw(ins.sommeil_bas)) : null} />
        </div>
      )}
    </section>
  );
};
